(function (module) {
  'use strict';
  module
    .controller('travelerManagementController', ['$scope', 'organizations', '$stateParams', 'progressBar', 'ngDialog', 'toastFactory',
      'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state', 'clientSelectService',
      function ($scope, organizations, $stateParams, progressBar, ngDialog, toastFactory, uiGridConstants, commonDialog,
        commonDialogMessage, $state, clientSelectService) {
          console.log(clientSelectService.getSelectedClient());
          if (clientSelectService.getSelectedClient() === undefined && clientSelectService.getSelectedClient().id === undefined) {
            //toastFactory.toast_info('Please select a client.');
          }
      }
  ]);
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/controllers/travelerManagementController.js